import { FormField, Select, Textarea } from '@cian/ui-kit';
import { ChangeEvent, FormEvent, ForwardedRef, forwardRef } from 'react';
import { EStatus, IOffer } from 'shared/types/listing';
import {
  formatArea,
  formatDate,
  formatLocation,
  formatNumber,
  formatObjectType,
  formatPhone,
  formatPriceType,
  formatRoomsCount,
  formatStatus,
  formatString,
  formatStringArray,
  getAreaLabel,
} from 'shared/utils/formatters';

export interface IDobroListingPopupContentProps {
  offer: IOffer;

  formStatus: EStatus;
  onFormStatusChange: (status: EStatus) => void;
  formComment: string;
  onFormCommentChange: (_: ChangeEvent, comment: string) => void;
  onSubmit: (e: FormEvent) => void;
}

export const DobroListingPopupContent = forwardRef(function DobroListingPopupContent(
  props: IDobroListingPopupContentProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  const { offer, formStatus, onFormStatusChange, formComment, onFormCommentChange, onSubmit } = props;

  return (
    <div>
      <div ref={ref} data-testid="DobroListingPopupContent">
        <p>
          <b>Статус:</b> {formatStatus(offer.status)}
          <br />
          <b>Дата создания:</b> {formatDate(offer.createdAt)}
        </p>
        <p>
          <b>Тип жилья:</b> {formatObjectType(offer.objectType)}
          <br />
          <b>Город:</b> {formatLocation(offer.location)}
          <br />
          <b>Адрес:</b> {formatString(offer.address)}
          <br />
          <b>Этаж:</b> {formatNumber(offer.floor)}
        </p>
        <p>
          <b>Кол-во комнат:</b> {formatRoomsCount(offer.roomsCount)}
          <br />
          <b>{getAreaLabel(offer.objectType)}:</b> {formatArea(offer.area)}
          <br />
          <b>Кол-во гостей:</b> {formatNumber(offer.guestsCount)}
          <br />
          <b>Кол-во спальных мест:</b> {formatNumber(offer.bedsCount)}
          <br />
          <b>Спальные места:</b> {formatString(offer.bedsDescription)}
        </p>
        <p>
          <b>В жилье есть:</b> {formatStringArray(offer.facilities)}
        </p>
        <p>
          <b>На сколько готовы принять:</b> {formatString(offer.availablePeriod)}
          <br />
          <b>На какой основе:</b> {formatPriceType(offer.priceType)}
          <br />
          <b>Сумма или комментарий:</b> {formatString(offer.priceDescription)}
          <br />
          <b>Могу принять:</b> {formatStringArray(offer.availableFor)}
          <br />
          <b>Есть пожелания:</b>{' '}
          {offer.otherWishes ? <span style={{ whiteSpace: 'pre' }}>{offer.otherWishes}</span> : '—'}
        </p>
        <p>
          <b>Имя и фамилия:</b> {formatString(offer.name)}
          <br />
          <b>Телефон:</b>: {formatPhone(offer.phone)}
          <br />
          <b>Дополнительный телефон:</b> {formatPhone(offer.additionalPhone)}
          <br />
          <b>Ник в Telegram:</b> {formatString(offer.telegram || '')}
        </p>
        <p>
          <b>Комментарий:</b> {offer.comment ? <span style={{ whiteSpace: 'pre' }}>{offer.comment}</span> : '—'}
        </p>
      </div>
      <form onSubmit={onSubmit} data-testid="DobroListingPopupContent-form">
        <FormField label="Статус">
          <Select
            value={formStatus}
            onChange={onFormStatusChange}
            options={[
              { value: EStatus.New, label: formatStatus(EStatus.New) },
              { value: EStatus.Phone_not_available, label: formatStatus(EStatus.Phone_not_available) },
              { value: EStatus.Canceled, label: formatStatus(EStatus.Canceled) },
              { value: EStatus.Confirming, label: formatStatus(EStatus.Confirming) },
              { value: EStatus.Busy, label: formatStatus(EStatus.Busy) },
              { value: EStatus.Available, label: formatStatus(EStatus.Available) },
            ]}
          />
        </FormField>
        <div data-testid="DobroListingPopupContent-form-comment">
          <FormField label="Комментарий">
            <Textarea value={formComment} onChange={onFormCommentChange} />
          </FormField>
        </div>
      </form>
    </div>
  );
});
